var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btnCom",style:({
              background: ("url('" + (_vm.configImgUrl()) + (_vm.config.background) + "')")
          }),on:{"click":_vm.getbtnClick}},[_c('div',{style:({
              textAlign:_vm.config.font.align,
             })},[_c('span',{style:({
              color:_vm.config.font.color,
              fontFamily:_vm.config.font.fontFamily,
              fontSize:_vm.config.font.fontSize +'px',
              fontWeight:_vm.config.font.fontWeight,
              lineHeight:_vm.trans.height +'px',
             })},[_vm._v("\n      "+_vm._s(_vm.config.font.centent))])])])}
var staticRenderFns = []

export { render, staticRenderFns }